module.exports = __webpack_public_path__ + "static/media/blackAndWhiteCity.2a5b88ea.jpg";